import { ENDPOINT, requestOptions } from '../utils/settings'

import type { PdfRender, PdfRenderProperties } from '../utils/types'

export async function pdfRenderProperties({
    depthPerInch,
    span,
    spanDepth,
    timePerInch
}: PdfRenderProperties): Promise<PdfRender> {
    try {
        const myHeaders = new Headers()
        myHeaders.append('Accept', 'application/json')
        myHeaders.append('Content-type', 'application/json')

        const properties = await fetch(`${ENDPOINT}/pdf/render-properties`, {
            ...requestOptions,
            method: 'POST',
            body: JSON.stringify({
                depthPerInch,
                span,
                spanDepth,
                timePerInch
            }),
            headers: myHeaders,
            redirect: 'follow'
        }).then(response => response.json())

        return properties
    } catch (error) {
        console.error(error)
        return null
    }
}
